import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AiOutlineDownload } from "react-icons/ai";
import marksentryapi from '../api/resultDeclarationRouter';
import loginapi from '../api/login';


import { APISERVERURL } from '../APIServerURL';


const Course = ({ course, session,accessToken,setAccessToken,setRefreshFailed }) => {
  const navigate = useNavigate();

  const [isDownloading,setIsDownloading]=useState(false);

  const handleCardClick = (semester) => {
    const mainElement = document.querySelector("main"); // Target <main> directly
    if (mainElement) {
        sessionStorage.setItem("scrollPosition", mainElement.scrollTop); // Save scroll position
        //alert(`Saved Scroll Position: ${mainElement.scrollTop}`);

    }
    navigate(`/resultdeclarationform/${course.batch}/${session}/${semester}`);
};


 function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }
  async function handleDownloadGradeCards(e,bg)
    {
      e.preventDefault();
      setIsDownloading(true);
      try{
        //session, batch, semester,bg
        const response= await marksentryapi.post('/getGradecardsOfABatch',{session,batch:course.batch,bg:'YES'},{headers:{'Authorization':`Bearer ${accessToken}`}});    
        alert(response.data);
        downloadFile(response.data);
      }
      catch(err)
      {
        try{
          const config = { withCredentials: true };
          const x=await loginapi.get('/getAccessToken',config);
          
          const nat=x['data']['accessToken'];
          setAccessToken(nat);
          try{       
            const response= await marksentryapi.post('/getGradecardsOfABatch',{session,batch:course.batch,bg:'YES'},{headers:{'Authorization':`Bearer ${nat}`}});    
            downloadFile(response.data);
           }
           catch(err)
           {
            alert('unusual error newposts.js');
           }
        }
        catch(err)
        {
          alert('failed');
        }

      }
      finally
      {
        setIsDownloading(false);
      }
    }
  return (
    <div      
      className="w-full shadow-lg rounded-xl px-4 py-2 flex flex-col justify-center hover:shadow-xl transition-shadow duration-300 
          bg-transparent  text-gray-800 "
      >
      <p className="w-full text-xs text-center font-semibold mb-2">{course.batch}-{course.level}</p>
      <p className="w-full text-sm text-center mb-3 font-semibold ">
        {course.noOfStudents} <span className="text-xs">STUDENTS</span>
      </p>

      {/* Semester-wise Cards */}
      <div className="flex flex-wrap justify-center gap-2">
        {course.semesterArray.map((sm, index) => (
          <div
            key={index}
            className={
              `w-24 h-24 bg-white cursor-pointer shadow-md rounded-lg flex flex-col items-center justify-center text-gray-800 border border-gray-300
              ${
                sm.submission_status === "declared"
                  ? "bg-gradient-to-r from-green-300 to-green-200 hover:from-green-600 hover:to-green-400 text-black"
                  : "bg-gradient-to-r from-pink-300 to-pink-600 hover:from-pink-500 hover:to-pink-700 text-white"
              }
              `
            }
           onClick={() => handleCardClick(sm.semester)}
          >
            <p className="text-sm font-semibold">Sem {sm.semester}</p>
            <p className="text-xs text-gray-600 font-semibold">{sm.noOfStudents} students</p>
          </div>
        ))}
      </div>
      <div className="flex flex-wrap justify-center gap-2 m-3">
        <button 
  onClick={(e) => handleDownloadGradeCards(e, 'yes')} 
  disabled={isDownloading}
  className={`flex items-center gap-2 px-4 py-2 rounded-lg transition duration-200 text-xs 
              ${isDownloading ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-500 hover:bg-blue-800 text-white'}`}
>
  {isDownloading ? (
    <span>Please Wait...</span>
  ) : (
    <>
      <AiOutlineDownload size={20} />
      GradeCards
    </>
  )}
</button>
      </div>
    </div>
  );
};

export default Course;
